import React from "react";
import {TableRowColumn} from 'material-ui/Table';
import 'react-tippy/dist/tippy.css'
import {Tooltip} from 'react-tippy';
import AvailabilityCellHover from './AvailabilityCellHover';
import * as DateUtil from "../utils/DateUtil";
import classNames from 'classnames';

const AvailabilityCell = ({rateByDay, customer, showRate, date}) => {
  const styles = {
    customStyle: {
      textOverflow: 'clip',
    },
  };

  const hover = ((!rateByDay || rateByDay.roomsRemaining <= 0) ? 'Room has been sold out.' :
      (showRate ? <AvailabilityCellHover rateByDay={rateByDay}/> :
          'Room is available.'));

  const rate_value = (showRate, rateByDay, colorsOnly) => {
    if(!colorsOnly) {
      if (!rateByDay || rateByDay.roomsRemaining <= 0) {
        return ('Sold')
      } else {
        if (showRate) {
          if (rateByDay.type === 'P') {
            return ((Number.parseInt(rateByDay.sharingPP, 10)
                * 2).toLocaleString())
          }
          else {
            return ((Number.parseInt(rateByDay.roomRate, 10)).toLocaleString())
          }
        }
        else {
          return (Number.parseInt(rateByDay.roomsRemaining,
              10).toLocaleString())
        }
      }
    }
    else {
      return <div style={{width: '100%', height: 15}}>{'   '}</div>;
    }
  };

  const cellStyle = (rateByDay, colorsOnly) => {
    let isWeekend = (rateByDay && DateUtil.isWeekend(DateUtil.localDateFromString(rateByDay.date)));//DateUtil.isWeekend(rateByDay.date);
    let available = (rateByDay && rateByDay.roomsRemaining > 0);
    return classNames(
        { "rateGridSoldOut" :  !available},
        { "rateGrid" :  available},
        { "weekend" :  isWeekend },
        { "week" :  !isWeekend },
        { "available-week" :  !isWeekend && colorsOnly && available },
        { "available-weekend" :  isWeekend && colorsOnly && available },
        { "sold-week" :  !isWeekend && !available },
        { "sold-weekend" :  isWeekend && !available },
    )
  };

  return (
      <TableRowColumn className={cellStyle(rateByDay, customer.colorsOnly)} style={styles.customStyle}>
        <Tooltip trigger="mouseenter"
                 size='small'
                 arrow={true}
                 theme={showRate ?'light' : 'dark'}
                 position='right'
                 interactive
                 html={(hover)}
        >
          <p>{rate_value(showRate, rateByDay, customer.colorsOnly)}</p>
        </Tooltip>
      </TableRowColumn>
  )
};


export default AvailabilityCell;


// WEBPACK FOOTER //
// ./src/components/AvailabilityCell.js